module.exports = __webpack_public_path__ + "static/media/VIe.8d30af83.png";